import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { StaffCommentSubjectInput } from '../../../lib/types/models/staff-comment-subject/staff-comment-subject-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { createStringSchema } from '../../../lib/utils/validations/string-validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'
import ValidationButtons from '../../elements/validation-buttons'

type Props = BaseFormProps<StaffCommentSubjectInput> & {
  className?: string
}

const formSchema: ZodType<StaffCommentSubjectInput> = z.object({
  name: createStringSchema('NOM')
})

const StaffCommentSubjectsForm = ({
  className,
  defaultValues,
  ...validationButtonProps
}: Props) => {
  const form = useForm<StaffCommentSubjectInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={className}>
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput required type="text" label="NOM" {...field} />
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default StaffCommentSubjectsForm
